import { provideSdHtmlSanitizer } from '@sidedrawer/ui/html-sanitizer';
import { environment } from '../../../environments/environment';
import {
  getAllowedImageHostsFromCdn,
  getAppRelativeUrlBase,
} from '../helpers/sd-content-html-hosts.helper';

/** Registers {@link provideSdHtmlSanitizer} for all MY client bootstraps. */
export function provideAppSdHtmlSanitizer() {
  return provideSdHtmlSanitizer({
    allowedImageHosts: getAllowedImageHostsFromCdn(environment.cdn),
    relativeUrlBase: getAppRelativeUrlBase(),
  });
}
